module.exports = __webpack_public_path__ + "img/003-facebook.d174619f.svg";